import { Injectable } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { GlobalLoaderService } from '../services/global-loader.service';

@Injectable()
export class GlobalLoaderInterceptor implements HttpInterceptor {

  constructor(private globalLoader: GlobalLoaderService) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    // Trigger the global loader
    this.globalLoader.triggerAuto();

    return next.handle(request)
      .pipe(
        tap((event) => {
          // Success requests
          if (event instanceof HttpResponse) {
            this.globalLoader.completeAuto();
          }
        }, () => {
          // Request failed!
          this.globalLoader.completeAuto();
        })
      );
  }
}
